<nav class="navbar navbar-expand-lg navbar-dark bg-darkblue">
  <div class="container">
    <img
      routerLink="/"
      class="navbar-brand pointer"
      src="public/logo/Hilbertech.svg"
      alt="Hilbertech"
    />
    <button
      routerLink="/"
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse px-3 justify-content-center"
      id="navbarNav"
    >
      <ul class="navbar-nav gap-4">
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLink="/"
            >{{ "navbar.home" | translate }}</a
          >
        </li>

        <li class="nav-item dropdown position-static">
          <a
            class="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            routerLinkActive="active-link"
          >
            {{ "navbar.company" | translate }}
          </a>

          <div class="dropdown-menu mega-menu py-lg-5 py-3">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-md-3 company-separator">
                  <h2 class="fw-bold px-3">Company</h2>
                </div>

                <div class="col-md-9 d-flex gap-5 px-4">
                  <a class="nav-link fw-semibold" routerLink="/about">
                    {{ "navbar.company1" | translate }}
                  </a>
                  <a class="nav-link fw-semibold" routerLink="/careers">
                    {{ "navbar.company2" | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/faq"
            routerLinkActive="active-link"
            >{{ "navbar.faq" | translate }}</a
          >
        </li>
      </ul>
    </div>
    <button
      class="btn btn-outline-light d-none d-lg-block"
      routerLink="/contact"
    >
      {{ "navbar.contactUs" | translate }}
    </button>
  </div>
</nav>
